import { render, staticRenderFns } from "./AITest.vue?vue&type=template&id=dc516a68&scoped=true&"
import script from "./AITest.vue?vue&type=script&lang=js&"
export * from "./AITest.vue?vue&type=script&lang=js&"
import style0 from "./AITest.vue?vue&type=style&index=0&id=dc516a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc516a68",
  null
  
)

export default component.exports